import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class UtilityService
{
    private activeMenuItems = new BehaviorSubject<any>({});
    public setActiveMenuItems(value:{}){
      this.activeMenuItems.next(value);
    }
    public activeMenuItems$ = this.activeMenuItems.asObservable();
}